import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { useAppDispatch, useAppSelector } from "../../../Hooks/useStore";
import { useCallback } from "react";

export type DiscountCodeTypes = {
  type: string;
  code: string;
};

export type DiscountCodeInitialStateTypes = {
  discountCode: DiscountCodeTypes | null;
};
const initialState = {} as DiscountCodeInitialStateTypes;

export const discountCodeSlice = createSlice({
  initialState,
  name: "discountCodeSlice",
  reducers: {
    setDiscountCode: (
      state,
      action: PayloadAction<DiscountCodeTypes | null>,
    ) => {
      state.discountCode = action.payload;
    },
  },
});

export const { setDiscountCode } = discountCodeSlice.actions || {};
export default discountCodeSlice.reducer;

export const useDiscountCode = () => {
  const { discountCode } = useAppSelector((state) => state.discountCode);
  const dispatch = useAppDispatch();

  const dispatchSetDiscountCode = useCallback(
    (data: DiscountCodeTypes | null) => {
      dispatch(setDiscountCode(data));
    },
    [dispatch],
  );

  return {
    discountCode,
    dispatchSetDiscountCode,
  };
};
